"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var MultiCurrencyPrice_1 = require("./multiCurrency/MultiCurrencyPrice");
var PriceWithLabel_1 = require("../price/priceWithLabel/PriceWithLabel");
var CashPricesLabel_1 = require("./label/CashPricesLabel");
var PriceDisplayType_1 = require("../../../../../../../../common/enum/PriceDisplayType");
var core_1 = require("@material-ui/core");
var Typography_1 = require("@material-ui/core/Typography");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var cashPricesStyles_1 = require("./cashPricesStyles");
var CashPrices = function (_a) {
    var primaryPrice = _a.primaryPrice, isMultiCurrency = _a.isMultiCurrency, secondaryPrice = _a.secondaryPrice, dataTest = _a.dataTest, hideLabel = _a.hideLabel, taxLabel = _a.taxLabel;
    var _b, _c;
    var style = cashPricesStyles_1.default();
    var isFromAltSpc = core_1.useTheme().checkoutLite.isFromAltSpc;
    if (isMultiCurrency) {
        return (<MultiCurrencyPrice_1.default primaryPrice={primaryPrice} secondaryPrice={secondaryPrice} dataTest={dataTest} hideLabel={hideLabel}/>);
    }
    return (<PriceWithLabel_1.default price={(_b = primaryPrice) === null || _b === void 0 ? void 0 : _b.money.amount} priceDisplayType={PriceDisplayType_1.PriceDisplayType.PRIMARY} currency={(_c = primaryPrice) === null || _c === void 0 ? void 0 : _c.money.currency} dataTest={dataTest} label={!hideLabel && <CashPricesLabel_1.default />} taxLabel={taxLabel} labelBefore={isFromAltSpc && (<Typography_1.default variant={'h3'} className={style.labelBefore}>
            <Translation_1.default id={'trans__checkout__vehicle_details__price_finance_from_label'}/>
          </Typography_1.default>)}/>);
};
exports.default = CashPrices;
